var $f510599a6178d1bd$exports = {};
$f510599a6178d1bd$exports = {
  "backButton": args => "Nazaj na ".concat(args.prevMenuButton),
  "moreActions": "Ve\u010D mo\u017Enosti",
  "unavailable": "Ni na voljo, raz\u0161irite za podrobnosti"
};
export { $f510599a6178d1bd$exports as default };